var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-select',{attrs:{"label":_vm.label,"keys":{ label:'name', value: 'id' },"placeholder":"Pick a Team Member","options":_vm.options,"disabled":_vm.isLoading,"icon":_vm.icon,"has-search":true},on:{"change":_vm.handleChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }